goog.provide("shadow.js.shim.module$moment_timezone");
goog.provide("module$shadow_js_shim_module$moment_timezone");
shadow.js.shim.module$moment_timezone = shadow.js.nativeProvides["moment-timezone"] = shadow$bridge("moment-timezone");
module$shadow_js_shim_module$moment_timezone.default = shadow.js.shim.module$moment_timezone;
